import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import "../styles/DetalleEspecialidad.css";

const DetalleEspecialidad = () => {
  const { nombre } = useParams(); // Nombre de la especialidad desde la URL
  const navigate = useNavigate();

  const [especialidad, setEspecialidad] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [profesionales, setProfesionales] = useState([]);
  const [loadingProfesionales, setLoadingProfesionales] = useState(true);

  useEffect(() => {
    const fetchEspecialidad = async () => {
      try {
        // Obtener la especialidad por nombre
        const encodedNombre = encodeURIComponent(nombre).replace(/\+/g, '%20');
        const response = await axios.get(`https://vortexcode.cl/api/especialidad/nombre/${encodedNombre}`);
        setEspecialidad(response.data);

        if (response.data?.id_especialidad) {
          // Usar el ID de la especialidad para obtener los profesionales
          fetchProfesionales(response.data.id_especialidad);
        } else {
          setError('No se encontró la especialidad');
        }

        setLoading(false);
      } catch (err) {
        setError('Error al cargar los detalles de la especialidad');
        setLoading(false);
      }
    };

    const fetchProfesionales = async (idEspecialidad) => {
      try {
        // Obtener los profesionales relacionados con la especialidad
        const response = await axios.get('https://vortexcode.cl/api/profesional', {
          params: { especialidad: idEspecialidad }
        });

        // Mostrar todos los profesionales relacionados con la especialidad
        setProfesionales(response.data);
        setLoadingProfesionales(false);
      } catch (err) {
        console.error('Error al cargar los profesionales:', err);
        setLoadingProfesionales(false);
      }
    };

    if (nombre) {
      fetchEspecialidad();
    } else {
      setError('Nombre de especialidad no proporcionado');
      setLoading(false);
    }
  }, [nombre]);

  if (loading) return <div className="text-center mt-4">Cargando...</div>;
  if (error) return <div className="alert alert-danger mt-4">{error}</div>;
  if (!especialidad) return <div>No se encontró la especialidad</div>;

  return (
    <div id="detalleEspecialidad" className="container">
      <div id="headerEspecialidad">
        <div id="headerLeft">
          <div
            id="iconoDetalle"
            dangerouslySetInnerHTML={{ __html: especialidad.img_especialidad }}
          />
          <h1>{especialidad.nombre_especialidad}</h1>
        </div>
        <button id="btnReservar" onClick={() => navigate('/reserva')}>
          RESERVAR HORA
        </button>
      </div>

      <section id="descripcion">
        <h2>¿Qué es la {especialidad.nombre_especialidad}?</h2>
        <p>{especialidad.desc_especialidad}</p>
      </section>

      <section id="cuandoAcudir">
        <h2>¿Cuándo acudir?</h2>
        <div className="cuándo-lista">
          {especialidad.cuando ? (
            especialidad.cuando.split('|').map((item, index) => (
              <div className={`cuándo-item ${index === 0 ? 'activo' : ''}`} key={index}>
                <span className="texto">{item}</span>
                <span className="icono">+</span>
              </div>
            ))
          ) : (
            <p>No se especificaron recomendaciones.</p>
          )}
        </div>
      </section>
      <section id="especialistasPorEspecialidad">
  <h2 className="text-center mb-4">ESPECIALISTAS</h2>

  {loadingProfesionales && <p className="text-center">Cargando especialistas...</p>}

  {!loadingProfesionales && profesionales.length === 0 && (
    <p className="text-center">
      Aún no se encuentran disponibles los profesionales en esta especialidad. Puedes consultar la disponibilidad en el botón RESERVAR HORA.
    </p>
  )}

  {!loadingProfesionales && profesionales.length > 0 && (
    <div id="profesionalesList" className="row">
      {profesionales.map((profesional) => (
        <div key={profesional.id_profesional} className="col-12 col-md-6 col-lg-3 mb-4">
          <div className="profesionalCard">
            <Link to={`/profesional/${profesional.id_profesional}`} className="cardLink">
              <div className="profesionalCircle">
                <img
                  src={profesional.img_profesional}
                  alt={profesional.nombre_profesional}
                  className="professionalImg"
                />
              </div>
              <p className="nombre">{profesional.nombre_profesional} {profesional.apaterno_profesional}</p>
              <p className="rango-etario">Rango etario de: {profesional.rango_inferior} a {profesional.rango_superior}</p>
              <p className="especialidad">{profesional.nombre_especialidad}</p>
              <p className="descripcion">{profesional.desc_profesional}</p>
            </Link>
            <button
              className="btn btn-link verMasBtn"
              onClick={() => navigate(`/profesional/${profesional.id_profesional}`)}
            >
              Ver más
            </button>
          </div>
        </div>
      ))}
    </div>
  )}
</section>
    </div>
  );
};

export default DetalleEspecialidad;